// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';

import styles from './styles';

class Paragraph extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    text: PropTypes.string,
    number: PropTypes.string,
    bold: PropTypes.bool,
  };

  static defaultProps = {
    classes: {},
    text: 'no text',
    number: null,
    bold: false,
  };

  render() {
    const {
      classes,
      text,
      number,
      bold,
    } = this.props;

    return (
      <div className={classes.mainContainer}>
        <span className={classNames(classes.text, bold ? classes.bold : classes.regular)}>
          {number && <span className={classes.number}>{number}</span>}
          {text}
        </span>
      </div>
    );
  }
}

export default withStyles(styles)(Paragraph);
